import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  width: 100%;
  padding: 20px;
  animation: rendering 0.5s;

  > h1 {
    font-family: 'Aller-Bold';
    font-size: 2rem;
    color: #165011;
    margin-bottom: 40px;
  }

  > div:nth-of-type(1) {
    font-family: 'Aller-Regular';
    font-size: 1.5rem;
    color: #165011;
  }

  > button {
    font-family: 'Aller-Regular';
    font-size: 1.5rem;
    width: 380px;
    height: 60px;
    margin-top: 40px;
  }

  > div:nth-of-type(2) {
    font-size: 1.5rem;
    width: 380px;
    height: 60px;
    margin-top: 20px;
  }

  @media (max-width: 26.25rem) {
    > button {
      width: 100%;
    }

    > div:nth-of-type(2) {
      width: 100%;
    }
  }
`;
